import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "components/Typography";

interface Props {
  label: string;
  value?: string;
  align?: "center" | "right" | "left";
  weight?: "500";
}

function LiveActivityFeedVirtualTableRowCell(props: Props) {
  const { align = "center", weight } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: align,
      }}
    >
      <Box>
        <Typography variant="TextXS" sx={{ color: theme.palette.grey[120] }}>
          {props.label}
        </Typography>
      </Box>
      <Typography variant="TextS" sx={{ fontWeight: weight }}>
        {props.value}
      </Typography>
    </Box>
  );
}

export default LiveActivityFeedVirtualTableRowCell;
